import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 12000,
});

export const fetchApps = async () => {
  const { data } = await client.get("/apps");
  return data;
};

export const trackClick = async (slug) => {
  const { data } = await client.post(`/apps/${slug}/click`);
  return data;
};

export const fetchStats = async () => {
  const { data } = await client.get("/stats");
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await client.post("/contact", payload);
  return data;
};

export default client;
